var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1Coordinate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1705_26101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04148 3.5H2.01431C2.05892 2.7268 2.20614 2.01454 2.43322 1.44114C1.70876 1.88567 1.18757 2.62924 1.04148 3.5ZM4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0ZM4 1C3.96198 1 3.88393 1.01586 3.76735 1.13092C3.64862 1.2481 3.51876 1.44245 3.39891 1.72209C3.20457 2.17555 3.06245 2.79279 3.01618 3.5H4.98382C4.93755 2.79279 4.79543 2.17555 4.60109 1.72209C4.48124 1.44245 4.35138 1.2481 4.23265 1.13092C4.11607 1.01586 4.03802 1 4 1ZM5.98569 3.5C5.94108 2.7268 5.79386 2.01454 5.56678 1.44114C6.29124 1.88567 6.81244 2.62924 6.95852 3.5H5.98569ZM4.98382 4.5H3.01618C3.06245 5.20721 3.20457 5.82445 3.39891 6.27791C3.51876 6.55755 3.64862 6.7519 3.76735 6.86908C3.88393 6.98414 3.96198 7 4 7C4.03802 7 4.11607 6.98414 4.23265 6.86908C4.35138 6.7519 4.48124 6.55755 4.60109 6.27791C4.79543 5.82445 4.93755 5.20721 4.98382 4.5ZM5.56678 6.55886C5.79386 5.98546 5.94108 5.2732 5.98569 4.5H6.95852C6.81244 5.37076 6.29124 6.11433 5.56678 6.55886ZM2.43322 6.55886C2.20614 5.98546 2.05892 5.2732 2.01431 4.5H1.04148C1.18757 5.37076 1.70876 6.11433 2.43322 6.55886Z",
    fill: "#A3A4AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1705_26101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Coordinate);
export default __webpack_public_path__ + "static/media/1_coordinate.f646cb64ff96538556392a80dda7d8f8.svg";
export { ForwardRef as ReactComponent };